<template>
  <div id="contents">
    <div class="recruit_welfare" >
      <div class="recruit_welfare_main">
        <div class="title_area">
          <div class="welfare_title_1">
            <p>「働きやすさ」</p>
          </div>
          <div class="welfare_title_2">
            <p>のために</p>
          </div>
        </div>
        <div @click="close" class="back_btn_icon">
          <img src="../assets/img/common/recruit_2021/close.png" alt="close">
        </div>
        <p class="caption">オフの時間も大切にしながらメリハリをつけて面白いコンテンツをつくれるよう、福利厚生や働く環境を充実させています。</p>
      </div>
      <div class="recruit_welfare_list">
        <div class="number_area">
          <p class="number"><img src="../assets/img/common/recruit_2021/point/01.png" alt="01"></p>
        </div>
        <div class="welfare">
          <p class="title">福利厚生</p>
          <ul class="list">
            <li class="item">
              <div class="title_area">
                <span class="green_line" ></span>
                <p class="title">東京ディズニーリゾート・<br />コーポレート利用券</p>
              </div>
              <p class="text">東京ディズニーリゾートを特別料金でお得に利用できます。</p>
            </li>
            <li class="item">
              <div class="title_area">
                <span class="green_line" ></span>
                <p class="title">厚生会マイチョイス</p>
              </div>
              <p class="text">1年間に一定のポイントが付与され、貯めたポイントをレジャー、エンターテイメント鑑賞、スポーツ観戦、習い事、エステなど自分の好きなことに使える、福利厚生プログラムです。</p>
            </li>
            <li class="item">
              <div class="title_area">
                <span class="green_line" ></span>
                <p class="title">保養所（リゾートホテル）</p>
              </div>
              <p class="text">「東急ハーヴェストクラブ」「みやび倶楽部」のリゾートホテルをお得に利用できます。</p>
            </li>
            <li class="item">
              <div class="title_area">
                <span class="green_line" ></span>
                <p class="title">チケットレストラン加盟店<br />食事補助</p>
              </div>
              <p class="text">全国59,000店以上の飲食店やコンビニで毎日利用できる、食事券補助サービスです。</p>
            </li>
            <li class="item">
              <div class="title_area">
                <span class="green_line" ></span>
                <p class="title">UberEats 食事補助</p>
              </div>
              <p class="text">Uber Eatsのサービス提供地域であれば利用可能です。</p>
            </li>
            <li class="item">
              <div class="title_area">
                <span class="green_line" ></span>
                <p class="title">クラブ活動補助</p>
              </div>
              <p class="text max_w_310">「野球部」「ゴルフ部」「ランニング部」「映像研究部」など、趣味の活動費用をサポートします。</p>
            </li>
            <li class="item">
              <div class="title_area">
                <span class="green_line" ></span>
                <p class="title">各種慶弔見舞金</p>
              </div>
              <p class="text">結婚、出産、子女の入学、弔慰などの際にお渡ししています。</p>
            </li>
            <li class="item">
              <div class="title_area">
                <span class="green_line" ></span>
                <p class="title">テレビ朝日健康保険組合</p>
              </div>
              <p class="text">人間ドック、「ベネフィットステーション（スポーツクラブ、映画、カラオケ、各種チケット等優待など）」をご利用いただけます。</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="recruit_welfare_list">
        <div class="number_area">
          <p class="number"><img src="../assets/img/common/recruit_2021/point/02.png" alt="02"></p>
        </div>
        <div class="work_environment">
          <p class="title">働く環境</p>
          <ul class="list">
            <li class="item">
              <div class="title_area">
                <span class="green_line" ></span>
                <p class="title">新オフィス</p>
              </div>
              <p class="text">2020年3月にリニューアルしてフリーアドレス化しました。ノートPCを配付し、自分の業務内容などに合わせて好きなエリアで仕事ができるようにしています。</p>
              <div class="image">
                <img src="../assets/img/common/recruit_2021/welfare/office_1.png" alt="オフィス">
                 <p>Photo  by TOMOOKI KENGAKU</p>
              </div>
            </li>
            <li class="item">
              <div class="title_area">
                <span class="green_line" ></span>
                <p class="title">iPhone貸与</p>
              </div>
              <p class="text">iPhoneを従業員全員に配付。効率的に仕事ができるようにしています。</p>
            </li>
            <li class="item">
              <div class="title_area">
                <span class="green_line" ></span>
                <p class="title">外部教育講座の受講</p>
              </div>
              <p class="text">人材育成及び定時退社の奨励策として、クリエイタースキルを高める外部講座の受講費用を会社で負担しています。積極的に活用してスキルアップにつなげてください。</p>
            </li>
            <li class="item">
              <div class="title_area">
                <span class="green_line" ></span>
                <p class="title">人材育成制度</p>
              </div>
              <p class="text">入社後は、新入社員研修で業務の基本を学びます。その後、1、2年目はジョブローテーションでさまざまな職種、現場を体験。その他、外部講師を招いた研修などでクリエイターとして必要な能力や知見を幅広く身につけていきます。また、実力主義の給与体系・評価制度を導入しており、がんばって成果を出した分、しっかり評価される環境です。</p>
              <div class="image">
                <img src="../assets/img/common/recruit_2021/welfare/teaching_1.png" alt="人材教育">
              </div>
            </li>
            <li class="item">
              <div class="title_area">
                <span class="green_line" ></span>
                <p class="title">メリハリをつけて働くための<br />休日休暇</p>
              </div>
              <p class="text">休日は、完全週休2日制（原則として土・日）。休暇として、夏季休暇（7月～11月で10連休も可）、冬季休暇（12月～3月で取得）、年末年始休暇、有給休暇、誕生日休暇、永年勤続特別休暇を整えています。また、育児介護支援制度もあるのでライフステージに応じた働き方が可能です。</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div><!-- #contents -->
</template>
<script>
export default {
  name: 'recruit_info',
  data() {
    return {
      info_post: null,
      request_id: null,
      loading: false,
      post_list: null,
      error: null,
    }
  },
  props: [
    'info_layout_status',
    'request_tag_id'
  ],
  mounted () {
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)
  },
  methods: {
    close(){
      this.$emit('close_icon');
    }
  },
}
</script>

<style scoped lang="sass">
  @mixin recruit_font($size, $line-height, $letter-spacing)
    font-family: 'Noto Sans JP', sans-serif
    font-weight: 700
    font-size: $size
    line-height: $line-height
    letter-spacing: $letter-spacing

  #contents
    width: 100vw
  .recruit_welfare
    padding-bottom: 77px
    &_main
      width: 90.4vw
      margin: calc(36.1vw - 41px) auto 0
      padding-bottom: 27px
      background-color: #fff
      position: relative
      .title_area
        position: absolute
        top: -25px
        left: 21px
        .welfare_title_1
          position: relative
          width: 202px
          height: 48px
          background: #64BC24
          p
            position: absolute
            left: -6px
            display: table
            white-space: nowrap
            @include recruit_font(26px, 48px, 0.176em)
            color: #fff
        .welfare_title_2
          position: relative
          width: 140px
          height: 35px
          background: #64BC24
          p
            position: absolute
            left: 6px
            display: table
            white-space: nowrap
            @include recruit_font(26px, 26px, 0.176em)
            color: #fff
      .caption
        @include recruit_font(12px, 23px, 0.196em)
        margin: calc(79px - 41px) 21px 0 21px
        width: 79.2vw
        display: inline-block
      a
        color: #000
        text-decoration: none
      .back_btn_icon
        position: absolute
        top: -20.9vw
        left: 0vw
        img
          width: 32px
          height: 32px
    &_list
      width: 90.4vw
      margin: 0 auto
      margin-top: 21px
      background-color: #fff
      position: relative
      .number_area
        position: absolute
        top: 16px
        left: -30px
        display: flex
      .number
        background: #64BC24
        padding: 6px 10px 2px 41px
        img
          width: 42px
          height: 38px
      .welfare
        padding-top: 20px
        padding-bottom: 24px
        .title
          @include recruit_font(24px, 36px, 0.138em)
          margin: 0 0 28px 80px
        .list
          padding: 0 8px 24px 21px
          li
            display: grid
            margin-bottom: 16px
            &:last-child
              margin-bottom: 0px
            .title_area
              display: flex
              align-items: center
              .green_line
                width: 8px
                height: 38px
                background-color: #64BC24
              .title
                width: 100%
                padding-left: 7px
                margin: 0
                @include recruit_font(16px, 23px, 0.196em)
                color: #64BC24
            .text
              max-width: 296px
              margin-top: 5px
              @include recruit_font(12px, 23px, 0.124em)
            .max_w_310
              max-width: 310px
          img
            width: 100%
      .work_environment
        padding-top: 20px
        padding-bottom: 24px
        .title
          @include recruit_font(24px, 36px, 0.138em)
          margin: 0 0 41px 80px
        .list
          padding: 0 8px 24px 21px
          li
            display: grid
            margin-bottom: 28px
            &:last-child
              margin-bottom: 0px
            .title_area
              display: flex
              align-items: center
              .green_line
                width: 8px
                height: 38px
                background-color: #64BC24
              .title
                width: 100%
                padding-left: 7px
                margin: 0
                @include recruit_font(16px, 23px, 0.196em)
                color: #64BC24
            .text
              max-width: 296px
              margin-top: 11px
              @include recruit_font(12px, 23px, 0.124em)
            .max_w_310
              max-width: 310px
            .image
              max-width: 296px
              margin-top: 16px
              img
                width: 100%
              p
                @include recruit_font(10px, 10px, 0.124em)
                margin-top: 10px
      .corona
        padding-top: 20px
        padding-bottom: 41px
        @media screen and (max-width: 374px)
          img
            width: 100%
        .title
          @include recruit_font(24px, 36px, 0.138em)
          margin: 0 0 41px 80px
        .content
          padding: 0 21px
          .caption
            @include recruit_font(12px, 23px, 0.124em)
            margin-bottom: 47px
          .measures_list
            &_item
              position: relative
              margin-bottom: 55px
              &:last-child
                margin-bottom: 0px
              &:nth-child(1)
                .measures_ttl
                  margin-bottom: 21px
                .img_01
                  margin-bottom: 22px
                .list
                  margin-bottom: 33px
                  padding-right: 15px
              &:nth-child(2)
                .list
                  margin-bottom: 28px
              &:nth-child(3)
                .measures
                  &_ttl
                    &::before
                      margin-right: 2px
                      @media screen and (max-width: 374px)
                        margin-right: 20px
                  &_desc
                    margin-bottom: 13px
                    padding-right: 0px
                    letter-spacing: 0.024em
                .list
                  li
                    margin-bottom: 18px
                    &:last-child
                      margin-bottom: 0
                    .text
                      margin-bottom: 17px
                    .img
                      margin-left: -25px
              .measures
                &_ttl
                  display: flex
                  align-items: center
                  margin-bottom: 21px
                  @include recruit_font(16px, 23px, 0.19em)
                  color: #64BC24
                  &::before
                    content: ""
                    display: inline-block
                    width: 8px
                    height: 37px
                    margin-right: 20px
                    background: #64BC24
                &_desc
                  margin-bottom: 25px
                  padding-right: 6px
                  @include recruit_font(14px, 26px, 0.1em)
              .list
                li
                  position: relative
                  margin-bottom: 18px
                  padding-left: 25px
                  @include recruit_font(12px, 22px, 0.09em)
                  &::before
                    content: ""
                    position: absolute
                    top: 3px
                    left: 0
                    width: 16px
                    height: 16px
                    border-radius: 8px
                    background: #64BC24
              .img_list
                li
                  margin-bottom: 23px
                  text-align: center
                  &:last-child
                    margin-bottom: 0
  @media screen and (max-width: 374px)
    #contents
    .recruit_welfare
      &_main
        margin: 85px auto 0
        .title_area
          left: 3.8vw
        .title
          @include recruit_font(26px, 42px, 1.5px)
        .caption
        a
        .more
          &_text
          &_arrow
        .back_btn_icon
          top: -78px
          left: 0vw
          img
      &_list
        &:last-child
        .number_area
        .number
          img
        .program
          .title
          .list
            li
            img
        .genre
          .title
          .text
          .list
            width: 90.4vw
            display: flex
            justify-content: center
            li
              width: 24vw
              height: 24vw
              &:not(:nth-child(3))
            .center
              li:first-child
              li:last-child
        .platform
          .title
          .text
          .list
            li
</style>



// WEBPACK FOOTER //
// src/components/recruit_welfare.vue